module.exports = window["wp"]["dataControls"];